import React, {useState} from 'react';
import Navigation from './Navigation';
import Footer from './Footer';
import "../style/App.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {TransformComponent, TransformWrapper} from "react-zoom-pan-pinch/dist";

function VajraVihar() {

    let [scal, setScal] = useState(0);
    let [imgsrc, setUrl] = useState("");

    function showPlan(event: any) {
        scal = 1;
        // alert(event.target.src);
        imgsrc = event.target.id;
        setUrl(imgsrc);
        // imgdrc
        setScal(scal);
    }

    function delPlan() {
        scal = 0;
        setScal(scal);
    }

    return (
        <div>
            <Navigation/>
            <div className="PlanDiv d-flex flex-row" style={{transform: "scale(" + scal + "," + scal + ")"}}>
                <button id="planbtn" className="close" onClick={delPlan}>&times;</button>

                <TransformWrapper
                    defaultScale={1}
                    defaultPositionX={200}
                    defaultPositionY={100}
                >
                    {({zoomIn, zoomOut, resetTransform, ...rest}: any) => (
                        <React.Fragment>

                            <div className="tools d-flex flex-lg-row flex-md-row flex-sm-row  flex-row">
                                <button id="btn111" className="btn  btnss" onClick={zoomIn}>Zoom In +</button>
                                <p/>
                                <button id="btn112" className="btn  btnss" onClick={zoomOut}>Zoom Out -</button>
                                <p/>
                                <button id="btn113" className="btn  btnss" onClick={resetTransform}>Reset</button>
                            </div>

                            <div className="mx-5 w-100 d-flex justify-content-center"
                                 style={{maxHeight: "90vh", overflow: "hidden", paddingTop: "5%"}}>
                                <TransformComponent>
                                    <img id="Plan1" className="d-block" alt="img" src={imgsrc}
                                         style={{width: "100vw"}}/>
                                </TransformComponent>

                            </div>

                        </React.Fragment>
                    )}
                </TransformWrapper>
            </div>
            <section className="hero-wrap hero-wrap-2" style={{backgroundImage: 'url("images/vajravihar.jpg")'}}
                     data-stellar-background-ratio="3">
                <div className="overlayy1"/>
                <div className="container">
                    <div className="row no-gutters slider-text js-fullheight align-items-center justify-content-center">
                        <div className="col-md-9 ftco-animate pb-0 text-center">
                            <h1 className="mb-3 bread">Vajra Vihar</h1>
                            <p>Vajra Vihar is a Government Approved & Licensed Colonisation. It is an initiative to
                                promote affordable housing solutions. It is a venture build and managed by highly
                                skilled professionals.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="ftco-section ftco-no-pb ftco-no-pt bg-darken" id="overview">
                <div className="container-fluid p-5">
                    <div className="row justify-content-center">
                        <div
                            className="col-12 text-white heading-section heading-section-white ftco-animate text-center">
                            <span className="subheading">Overview</span>
                            <h2 className="text-center text-white">Vajra Vihar</h2>
                            <p className="simple-text">Maintaining its high standards in quality construction and
                                customer satisfaction, the Dreamhome team tends forward to literally “Turn all your Real
                                Estates Dreams into Reality”

                            </p>

                            <p>It created especially for people who have taste and an eye for quality. Loaded with world
                                class living amenities, we have precisely planned every detail so that each home makes a
                                statement.</p>

                            <p>Vajra Vihar is the perfect home for families looking for a great lifestyle at a great
                                location. Plus, it offers all that an upward moving colony needs at a price that won’t
                                make a hole in your pocket.</p>
                            <h6>Book your dream home already!</h6>

                        </div>
                        <div className="col-lg-12 col-md-12 text-center d-lg-flex justify-content-around mt-3">
                            <div className="card d-inline-flex ftco-animate" style={{
                                background: "transparent",
                                border: "white",
                                margin: '.5%',
                                borderRadius: "50%"
                            }}>
                                <img alt="img" className="card-img-top vjracards"
                                     style={{width: "250px", height: "250px", borderRadius: "50%"}}
                                     src="https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?ixid=MXwxMjA3fDB8MHxzZWFyY2h8NHx8ZnVybml0dXJlfGVufDB8fDB8&ixlib=rb-1.2.1&w=1000&q=80"/>
                            </div>
                            <div className="card d-inline-flex ftco-animate" style={{
                                background: "transparent",
                                border: "white",
                                margin: '.5%',
                                borderRadius: "50%"
                            }}>
                                <img alt="img" className="card-img-top vjracards "
                                     style={{width: "250px", height: "250px", borderRadius: "50%"}}
                                     src="https://c4.wallpaperflare.com/wallpaper/196/892/8/modern-green-sofa-wallpaper-preview.jpg"/>
                            </div>
                            <div className="card d-inline-flex ftco-animate" style={{
                                background: "transparent",
                                border: "white",
                                margin: '.5%',
                                borderRadius: "50%"
                            }}>
                                <img alt="img" className="card-img-top vjracards"
                                     style={{width: "250px", height: "250px", borderRadius: "50%"}}
                                     src="https://i.pinimg.com/originals/e3/39/25/e339256df74a6d846c7efac07e15f5d5.jpg"/>

                            </div>
                            <div className="card d-inline-flex ftco-animate" style={{
                                background: "transparent",
                                border: "white",
                                margin: '.5%',
                                borderRadius: "50%"
                            }}>
                                <img alt="img" className="card-img-top vjracards"
                                     style={{width: "250px", height: "250px", borderRadius: "50%"}}
                                     src="https://www.hdfurniturestore.com/uploads/imagegallery/images/Category-Dining.jpg"/>
                            </div>
                        </div>

                        {/*<div className="col-lg-6 col-md-12 text-white text-lg-left text-md-center text-center pl-0 mt-3">*/}
                        {/*   */}
                        {/*</div>*/}

                    </div>
                </div>
            </section>

            <section className="ftco-section services-section bg-darken pt-5" id="features">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 text-center heading-section heading-section-white ftco-animate mb-5">
                            <span className="subheading">Features</span>
                            <h2 className="">Property Features</h2>
                        </div>
                        <div className="col-md-6 ftco-animate pb-3">
                            <div className="d-flex flex-column justify-content-center align-items-center" style={{
                                backgroundImage: 'url("./images/day2.png")',
                                backgroundSize: "cover",
                                height: "400px"
                            }}>
                                <div className="d-flex flex-column justify-content-center align-items-center"
                                     style={{background: "rgba(0,0,0,.7)", width: "100%", height: "100%"}}>
                                    <div className="ftco-animate display-3 text-white font-weight-bold">
                                        VAJRA
                                    </div>
                                    <div className="ftco-animate display-3 text-white font-weight-bold">
                                        VIHAAR
                                    </div>
                                    <h4 className="text-white">A Vision For Your Future</h4>
                                </div>

                            </div>
                            <div className="text-center pt-3"><h3 className="text-white">Year Built : 2020</h3><h3
                                className="text-white">Approved By Government</h3></div>
                        </div>
                        <div className="col-md-3 ftco-animate pl-5">
                            <div className=" wrap-about py-md-5 ftco-animate">
                                <div className="heading-section font-weight-bolder" style={{color: 'white'}}>
                                    <p><i className="fa fa-chevron-circle-right"/> &nbsp;&nbsp;21*45 Sq Feet</p>
                                    <p><i className="fa fa-chevron-circle-right"/> &nbsp;&nbsp;945 Sq Feet</p>
                                    <p><i className="fa fa-chevron-circle-right"/> &nbsp;&nbsp;3 Bedrooms</p>
                                    <p><i className="fa fa-chevron-circle-right"/> &nbsp;&nbsp;3 Baths</p>
                                    <p><i className="fa fa-chevron-circle-right"/> &nbsp;&nbsp;2 Storeys</p>
                                    <p><i className="fa fa-chevron-circle-right"/> &nbsp;&nbsp;Lobby</p>
                                    <p><i className="fa fa-chevron-circle-right"/> &nbsp;&nbsp;Kitchen</p>

                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 ftco-animate pl-5">
                            <div className=" wrap-about py-md-5 ftco-animate">
                                <div className="heading-section font-weight-bolder" style={{color: 'white'}}>
                                    <p><i className="fa fa-chevron-circle-right"/> &nbsp;&nbsp;Drawing Room</p>
                                    <p><i className="fa fa-chevron-circle-right"/> &nbsp;&nbsp;Open Spaces</p>
                                    <p><i className="fa fa-chevron-circle-right"/> &nbsp;&nbsp;Modern Architecture</p>
                                    <p><i className="fa fa-chevron-circle-right"/> &nbsp;&nbsp;Optimum Space Management
                                    </p>
                                    <p><i className="fa fa-chevron-circle-right"/> &nbsp;&nbsp;Premium Raw Materials</p>
                                    <p><i className="fa fa-chevron-circle-right"/> &nbsp;&nbsp;High Quality Standards
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>


            <div className="container" id="benefits">
                <div className="row">
                    <div className="col-md-12 text-center heading-section ftco-animate mb-5 mt-5">
                        <span className="subheading">Major</span>
                        <h2 className="mb-3">Benefits</h2>
                    </div>

                </div>
            </div>
            <section className="ftco-section ftco-no-pb ftco-no-pt bg-primary">
                <div className="container-fluid p-0">

                    <div className="row d-flex no-gutters">

                        <div className="col-md-2 d-flex align-items-stretch justify-content-around ftco-animate">
                            <div className="media block-6 services services-bg d-block text-center px-4 py-5"
                                 style={{width: '100%'}}>
                                <div className="icon d-flex justify-content-center align-items-center"><span
                                    className="flaticon-business"/></div>
                                <div className="media-body py-md-4">
                                    <h3>Government Approved Colonisation </h3>

                                </div>
                            </div>
                        </div>
                        <div className="col-md-2 d-flex align-items-stretch justify-content-around ftco-animate">
                            <div
                                className="media block-6 services services-bg services-darken d-block text-center px-4 py-5"
                                style={{width: '100%'}}>
                                <div className="icon d-flex justify-content-center align-items-center"><span
                                    className="flaticon-home"/></div>
                                <div className="media-body py-md-4">
                                    <h3>Water Supply</h3>

                                </div>
                            </div>
                        </div>
                        <div className="col-md-2 d-flex align-items-stretch justify-content-around ftco-animate">
                            <div
                                className="media block-6 services services-bg services-lighten d-block text-center px-4 py-5"
                                style={{width: '100%'}}>
                                <div className="icon d-flex justify-content-center align-items-center"><span
                                    className="flaticon-stats"/></div>
                                <div className="media-body py-md-4">
                                    <h3>Subsidy Of Rs. 2.67 Lakhs Available </h3>

                                </div>
                            </div>
                        </div>
                        <div className="col-md-2 d-flex align-items-stretch justify-content-around ftco-animate">
                            <div className="media block-6 services services-bg d-block text-center px-4 py-5"
                                 style={{width: '100%'}}>
                                <div className="icon d-flex justify-content-center align-items-center"><span
                                    className="flaticon-quarantine"/></div>
                                <div className="media-body py-md-4">
                                    <h3>Rain Water Harvesting</h3>

                                </div>
                            </div>
                        </div>
                        <div className="col-md-2 d-flex align-items-stretch justify-content-around ftco-animate">
                            <div
                                className="media block-6 services services-bg services-darken d-block text-center px-4 py-5"
                                style={{width: '100%'}}>
                                <div className="icon d-flex justify-content-center align-items-center"><span
                                    className="flaticon-business"/></div>
                                <div className="media-body py-md-4">
                                    <h3>Affordable Housing Under Pradhan Mantri Awaaz Yojana</h3>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-2 d-flex align-items-stretch justify-content-around ftco-animate">
                            <div
                                className="media block-6 services services-bg services-lighten d-block text-center px-4 py-5"
                                style={{width: '100%'}}>
                                <div className="icon d-flex justify-content-center align-items-center"><span
                                    className="flaticon-home"/></div>
                                <div className="media-body py-md-4">
                                    <h3>Sewage System</h3>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <section className="ftco-section ftco-no-pb ftco-no-pt bg-primary">
                <div className="container-fluid p-0">

                    <div className="row d-flex no-gutters">
                        <div className="col-md-2 d-flex align-items-stretch justify-content-around ftco-animate">
                            <div className="media block-6 services services-bg d-block text-center px-4 py-5"
                                 style={{width: '100%'}}>
                                <div className="icon d-flex justify-content-center align-items-center"><span
                                    className="flaticon-stats"/></div>
                                <div className="media-body py-md-4">
                                    <h3>Gated Colony</h3>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-2 d-flex align-items-stretch justify-content-around ftco-animate">
                            <div
                                className="media block-6 services services-bg services-darken d-block text-center px-4 py-5"
                                style={{width: '100%'}}>
                                <div className="icon d-flex justify-content-center align-items-center"><span
                                    className="flaticon-quarantine"/></div>
                                <div className="media-body py-md-4">
                                    <h3>Lush Green Parks</h3>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-2 d-flex align-items-stretch justify-content-around ftco-animate">
                            <div
                                className="media block-6 services services-bg services-lighten d-block text-center px-4 py-5"
                                style={{width: '100%'}}>
                                <div className="icon d-flex justify-content-center align-items-center"><span
                                    className="flaticon-business"/></div>
                                <div className="media-body py-md-4">
                                    <h3>24*7 Security</h3>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-2 d-flex align-items-stretch justify-content-around ftco-animate">
                            <div className="media block-6 services services-bg d-block text-center px-4 py-5"
                                 style={{width: '100%'}}>
                                <div className="icon d-flex justify-content-center align-items-center"><span
                                    className="flaticon-home"/></div>
                                <div className="media-body py-md-4">
                                    <h3>Underground Electrical Fittings</h3>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-2 d-flex align-items-stretch justify-content-around ftco-animate">
                            <div
                                className="media block-6 services services-bg services-darken d-block text-center px-4 py-5"
                                style={{width: '100%'}}>
                                <div className="icon d-flex justify-content-center align-items-center"><span
                                    className="flaticon-stats"/></div>
                                <div className="media-body py-md-4">
                                    <h3>Safe Neighbourhoods</h3>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-2 d-flex align-items-stretch justify-content-around ftco-animate">
                            <div
                                className="media block-6 services services-bg  services-lighten d-block text-center px-4 py-5"
                                style={{width: '100%'}}>
                                <div className="icon d-flex justify-content-center align-items-center"><span
                                    className="flaticon-quarantine"/></div>
                                <div className="media-body py-md-4">
                                    <h3>Fully Developed Roads</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="ftco-section services-section bg-darken pt-5" id="location">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 text-center heading-section heading-section-white ftco-animate mb-5">
                            <span className="subheading">Vajra Vihar's</span>
                            <h2 className="text-white">Location</h2>
                        </div>

                        <div className="col-md-12 ftco-animate pb-3 text-center">
                            <iframe className="locMap"
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d54558.37237130734!2d75.62769827281765!3d31.27890895615852!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391a596cee27a443%3A0xc5e65809563c2729!2sModi%20Resort!5e0!3m2!1sen!2sin!4v1608710840439!5m2!1sen!2sin"
                                    width="70%" height="450" frameBorder="0" style={{border: "0"}} allowFullScreen
                                    aria-hidden="false" tabIndex={0}/>
                        </div>

                    </div>
                </div>
            </section>

            <section className="ftco-section services-section bg-darken pt-5" id="plans">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 text-center heading-section heading-section-white ftco-animate mb-5">
                            <span className="subheading">Vajra Vihar's</span>
                            <h2>Master Plan</h2>
                        </div>
                        <div className="col-md-12 ftco-animate pb-3 text-center">

                            <div className="mapcontainer">
                                <img className="planImg ftco-animate" alt="img" src="./images/MasterPlan.jpg"
                                     title="Click To Zoom" style={{cursor: "pointer"}}/>
                                <div className="imgOverlay">
                                    <div className="imgText" id="./images/MasterPlan.jpg" onClick={showPlan}>Click To
                                        Zoom
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>
            <section className="ftco-section services-section bg-darken pt-5" id="plans">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 text-center heading-section heading-section-white ftco-animate mb-5">
                            <span className="subheading">Vajra Vihar's</span>
                            <h2>Floor Plan</h2>
                        </div>

                        <div className="col-md-12 ftco-animate pb-3 text-center">
                            <div className="mapcontainer">
                                <img alt="img" className="planImg ftco-animate" src="./images/FloorPlan.jpg"
                                     title="Click To Zoom" style={{cursor: "pointer"}}/>

                                <div className="imgOverlay">
                                    <div className="imgText" id="./images/FloorPlan.jpg" onClick={showPlan}>Click To
                                        Zoom
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="text-center pt-3"><h3 className="text-white ftco-animate">Government
                                Approved</h3></div>
                        </div>
                    </div>
                </div>
            </section>


            <section className="ftco-section services-section bg-darken pt-5" id="neighbourhood">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 text-center heading-section heading-section-white ftco-animate mb-5">
                            <span className="subheading">Know Your</span>
                            <h2 className="">Neighbourhood</h2>
                            <h5 className="text-white-50">The Following Amenities Are Within The Nearby Vicinity Of
                                Vajra Vihar</h5>
                        </div>
                        <div className="col-md-4 ftco-animate pl-5">
                            <div className=" wrap-about py-md-5 ftco-animate">
                                <div className="heading-section font-weight-bolder" style={{color: 'white'}}>
                                    <p><i className="fa fa-coffee"/> &nbsp;&nbsp;Haveli</p>
                                    <p><i className="fa fa-institution"/> &nbsp;&nbsp;Rangla Punjab</p>
                                    <p><i className="fa fa-cutlery"/> &nbsp;&nbsp;Mc Donalds</p>
                                    <p><i className="fa fa-building"/> &nbsp;&nbsp;Multiple Banquets</p>
                                    <p><i className="fa fa-star"/> &nbsp;&nbsp;Subway</p>
                                    <p><i className="fa fa-shopping-cart"/> &nbsp;&nbsp;Shopping Mall</p>

                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 ftco-animate pl-5">
                            <div className=" wrap-about py-md-5 ftco-animate">
                                <div className="heading-section font-weight-bolder" style={{color: 'white'}}>
                                    <p><i className="fa fa-cutlery"/> &nbsp;&nbsp;Lucky Dhaba</p>
                                    <p><i className="fa fa-shopping-basket"/> &nbsp;&nbsp;Easy Day</p>
                                    <p><i className="fa fa-building"/> &nbsp;&nbsp;Local & Market Of Deep Nagar</p>
                                    <p><i className="fa fa-hand-grab-o"/> &nbsp;&nbsp;Gym</p>
                                    <p><i className="fa fa-cutlery"/> &nbsp;&nbsp;Burger King</p>
                                    <p><i className="fa fa-institution"/> &nbsp;&nbsp;Delhi Public School</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 ftco-animate pl-5">
                            <div className=" wrap-about py-md-5 ftco-animate">
                                <div className="heading-section font-weight-bolder" style={{color: 'white'}}>
                                    <p><i className="fa fa-mortar-board"/> &nbsp;&nbsp;Lovely Professional University
                                    </p>
                                    <p><i className="fa fa-subway"/> &nbsp;&nbsp;Railway Station</p>
                                    <p><i className="fa fa-hotel"/> &nbsp;&nbsp;Resort</p>
                                    <p><i className="fa fa-cutlery"/> &nbsp;&nbsp;KFC</p>
                                    <p><i className="fa fa-building"/> &nbsp;&nbsp;Carnival Cinema Multiplex</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/*<section className="ftco-section services-section bg-darken pt-5">*/}
            {/*    <div className="container">*/}
            {/*        <div className="row">*/}
            {/*            <div className="col-md-12 text-center heading-section heading-section-white ftco-animate mb-5">*/}
            {/*                <span className="subheading">Vajra Vihar's</span>*/}
            {/*                <h2 className="">Floor Plan</h2>*/}
            {/*            </div>*/}
            {/*            */}

            {/*        </div>*/}
            {/*    </div>*/}
            {/*</section>*/}

            {/*<section className="ftco-section services-section bg-darken pt-5">*/}
            {/*    <div className="container">*/}
            {/*        <div className="row">*/}
            {/*            <div className="col-md-12 text-center heading-section heading-section-white ftco-animate mb-5">*/}
            {/*                <span className="subheading">Amenities</span>*/}
            {/*                <h2 className="">Facilities</h2>*/}
            {/*            </div>*/}
            {/*            <div className="col-md-6 ftco-animate pb-3">*/}
            {/*                <div className="d-flex flex-column justify-content-center align-items-center" style={{ backgroundImage: 'url("./images/work-9.jpg")',backgroundSize:"cover",height:"400px" }}>*/}
            {/*                    <div className="d-flex flex-column justify-content-center align-items-center" style={{background:"rgba(0,0,0,.7)",width:"100%",height:"100%"}}>*/}
            {/*                        <div className="ftco-animate display-3 text-white font-weight-bold">*/}
            {/*                            VAJRA*/}
            {/*                        </div>*/}
            {/*                        <div className="ftco-animate display-3 text-white font-weight-bold">*/}
            {/*                            VIHAAR*/}
            {/*                        </div>*/}
            {/*                        <h4 className="text-white">A Vision For Your Future</h4>*/}
            {/*                    </div>*/}

            {/*                </div>*/}
            {/*                <div className="text-center pt-3"><h3 className="text-white">Year Built : 2020</h3><h3 className="text-white">Approved By Government</h3></div>*/}
            {/*            </div>*/}
            {/*            <div className="col-md-3 ftco-animate pl-5">*/}
            {/*                <div className=" wrap-about py-md-5 ftco-animate">*/}
            {/*                    <div className="heading-section font-weight-bolder" style={{color:'white'}}>*/}
            {/*                        <p><i className="fa fa-arrow-right"></i> &nbsp;&nbsp;21*45 Sq Feet</p>*/}
            {/*                        <p><i className="fa fa-arrow-right"></i> &nbsp;&nbsp;945 Sq Feet</p>*/}
            {/*                        <p><i className="fa fa-arrow-right"></i> &nbsp;&nbsp;3 Bedrooms</p>*/}
            {/*                        <p><i className="fa fa-arrow-right"></i> &nbsp;&nbsp;3 Baths</p>*/}
            {/*                        <p><i className="fa fa-arrow-right"></i> &nbsp;&nbsp;2 Storeys</p>*/}
            {/*                        <p><i className="fa fa-arrow-right"></i> &nbsp;&nbsp;Lobby</p>*/}
            {/*                        <p><i className="fa fa-arrow-right"></i> &nbsp;&nbsp;Kitchen</p>*/}

            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className="col-md-3 ftco-animate pl-5">*/}
            {/*                <div className=" wrap-about py-md-5 ftco-animate">*/}
            {/*                    <div className="heading-section font-weight-bolder" style={{color:'white'}}>*/}
            {/*                        <p><i className="fa fa-arrow-right"></i> &nbsp;&nbsp;Drawing Room</p>*/}
            {/*                        <p><i className="fa fa-arrow-right"></i> &nbsp;&nbsp;Open Spaces</p>*/}
            {/*                        <p><i className="fa fa-arrow-right"></i> &nbsp;&nbsp;Modern Architecture</p>*/}
            {/*                        <p><i className="fa fa-arrow-right"></i> &nbsp;&nbsp;Optimum Space Management</p>*/}
            {/*                        <p><i className="fa fa-arrow-right"></i> &nbsp;&nbsp;Premium Raw Materials</p>*/}
            {/*                        <p><i className="fa fa-arrow-right"></i> &nbsp;&nbsp;High Quality Standards</p>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            </div>*/}

            {/*        </div>*/}
            {/*    </div>*/}
            {/*</section>*/}

            <Footer/>
        </div>
    );

}

export default VajraVihar;
